import { useContext } from 'react'

import IncidentManegementContext from 'contexts/IncidentManegementContext'

const useIncidentManegement = () => {
  const context = useContext(IncidentManegementContext)

  if (context === undefined) {
    throw new Error(
      'useIncidentManegement must be used within a IncidentManegementContext.Provider',
    )
  }

  return {
    activeButton: context.activeButton,
    activeStep: context.activeStep,
    alreadySentCommunicationEmail: context.alreadySentCommunicationEmail,
    handleAdvanceStep: context.handleAdvanceStep,
    handleBack: context.handleBack,
    handleNext: context.handleNext,
    handleReturnStep: context.handleReturnStep,
    handleStep: context.handleStep,
    incident: context.incident,
    isCompleted: context.isCompleted,
    isDpo: context.isDpo,
    isShow: context.isShow,
    resetAdvanceStep: context.resetAdvanceStep,
    resetReturnStep: context.resetReturnStep,
    setActiveButton: context.setActiveButton,
    setActiveStep: context.setActiveStep,
    setAlreadySentCommunicationEmail: context.setAlreadySentCommunicationEmail,
    setIncident: context.setIncident,
    setShowButtons: context.setShowButtons,
    showButtons: context.showButtons,
    wantsToAdvanceStep: context.wantsToAdvanceStep,
    wantsToReturnStep: context.wantsToReturnStep,
  }
}

export default useIncidentManegement
